import TechTag from './TechTag';

export default TechTag;
